import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { UpdatePatientInforRoutingModule } from './update-patient-information.component.routing';
import { UpdatePatientInforComponent } from './update-patient-information.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    declarations: [
        UpdatePatientInforComponent
    ],
    imports: [UpdatePatientInforRoutingModule, SharedModule, ReactiveFormsModule, FormsModule, CommonModule],
    providers: [],
    bootstrap: []
})
export class UpdatePatientInforModule {
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/update-patient-information/update-patient-information.component.module.ts